import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';

interface QuickRedeemDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (notes: string) => Promise<void>;
  benefitName: string;
  memberName: string;
  isSubmitting: boolean;
}

const QuickRedeemDialog: React.FC<QuickRedeemDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  benefitName,
  memberName,
  isSubmitting,
}) => {
  const [notes, setNotes] = useState('');

  const handleConfirm = async () => {
    await onConfirm(notes);
    setNotes('');
  };

  const handleClose = () => {
    setNotes('');
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-md bg-slate-900 border-white/20 text-white">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">
            ¿Registrar canje?
          </DialogTitle>
        </DialogHeader>
        
        <div className="py-4 space-y-4">
          <div className="bg-white/5 rounded-xl p-4 space-y-2">
            <p className="text-white/60 text-sm">Beneficio</p>
            <p className="text-white font-semibold text-lg">{benefitName}</p>
          </div>
          
          <div className="bg-white/5 rounded-xl p-4 space-y-2">
            <p className="text-white/60 text-sm">Para</p>
            <p className="text-white font-semibold text-lg">{memberName}</p>
          </div>

          <div className="space-y-2">
            <Label className="text-white/60">Notas (opcional)</Label>
            <Textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Modelo específico, color, etc..."
              className="bg-white/10 border-white/20 text-white placeholder:text-white/40 resize-none"
              rows={2}
            />
          </div>
        </div>

        <DialogFooter className="flex gap-2">
          <Button
            variant="outline"
            onClick={handleClose}
            disabled={isSubmitting}
            className="flex-1 border-white/20 text-white hover:bg-white/10 bg-transparent"
          >
            Cancelar
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={isSubmitting}
            className="flex-1 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700"
          >
            {isSubmitting ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                Registrando...
              </>
            ) : (
              '✓ Confirmar Canje'
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default QuickRedeemDialog;
